import React from 'react';
import { connect, useDispatch } from 'react-redux';
import { setIsActive, setIsOpen as setIsMobileOpen } from '../Actions/Navigation.action';
import Navigation from '../Components/Navigation';
import NavigationMobile from '../Components/NavigationMobile';
import useIsMobile from '../Hooks/useIsMobile';
import { useScroll } from '../Hooks/useScroll';
    
const NavigationContainer = props => {
    const { active, miniCartOpen } = props
    const isMobile = useIsMobile()
    const dispatch = useDispatch()
    const ref = React.createRef()
    // const scroll = useScroll(true)

    // React.useEffect(() => {
    //     if(ref.current) {
    //         if(ref.current.getBoundingClientRect().top <= 0 && scroll != 0) {
    //             // stuck to top
    //             if(!active)
    //                 dispatch(setIsActive(true))
    //         }else if(active) {
    //             dispatch(setIsActive(false))
    //         }
    //     }
    // }, [scroll])

    const scrollObserver = new IntersectionObserver( 
        ([e]) => {
            dispatch(setIsActive(!e.isIntersecting))
        },
        { threshold: [1] }
    )

    React.useEffect(() => {
        if(ref && ref.current) {
            // Observe header, not the navbar element
            scrollObserver.observe(document.querySelector("header"))
        }
      }, [ref])

    React.useEffect(() => {
        var header = document.querySelector("header")
        if(header && typeof props.margin !== 'undefined') {
            header.style.top = props.margin + "px"
        }
    }, [props.margin])

    React.useEffect(() => {
        if(!isMobile) {
            dispatch(setIsMobileOpen(false))
            document.querySelector("#navbar").classList.remove("overlay")
        }
    }, [isMobile])
    
    return <>
        <Navigation {...props} ref={ref} active={active || miniCartOpen} isMobile={isMobile} />
        {isMobile && <NavigationMobile {...props} open={props.mobileOpen} active={active || miniCartOpen} />}
    </>
}

const mapStateToProps = state => {
    const { navigation, cart } = state
    return {
        ...navigation,
        showMiniCart: cart.showMiniCart,
        miniCartOpen: cart.showInfo
    }
}

const mapDispatchToProps = dispatch => {
    return {
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(NavigationContainer);